export default (to, from, next) => {

    const auth = window.$cookies.get('admin-jwt');
    console.log('auth', auth )

    if (auth) {
    console.log('auth' )
        
        next();
    } else {
    console.log('no-auth-admin' )

        next({ name: 'admin-login' });
    }
}
